import { configureStore } from '@reduxjs/toolkit'
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist'

import persistedReducer from './persistedReducer'

const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'menu/setLeftMenuData',
          'menu/setTopMenuData',
          'editor/setActiveEditor',
          'editor/setActivePortableTextEditor',
          'editor/setIsUnsavedChangesModal',
          'products/setProductOptions',
          'allTaxonomyItems/setAllTaxonomyItems',
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
        ],
        ignoredPaths: [
          'menu',
          'editor.activeEditorInstance',
          'editor.activeEditorSelectionRange',
          'editor.activePortableTextEditor', // Keep for backward compatibility
          'editor.unsavedChangesDiscardAction',
          'products.options',
          'allTaxonomyItems.list',
        ],
      },
      immutableCheck: false,
    }),
})

export const persistor = persistStore(store)

export default store

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
